import styled from 'styled-components';

import { ParagraphSmall } from 'components/Typography';

import {
  colorWhite,
  color9,
  colorPrimary,
  colorBlack900,
  colorBlueGray,
  mediaQueryTabletMin,
} from 'styles/variables';

export const Wrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  padding-right: 60px;
  font-size: 28px;
  line-height: 33px;
  font-weight: bold;
  color: ${colorBlack900};
  border: 0;
  outline: 0;
  width: 100%;

  &:disabled {
    background: ${colorWhite};
    font-weight: normal;
    color: ${color9};
  }

  &[type='number'] {
    appearance: textfield;
  }

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 110px;
  padding: 8px 16px 4px;
  border: 1px solid ${colorBlueGray};
  border-radius: 2px;

  @media ${mediaQueryTabletMin} {
    padding-bottom: 8px;
  }

  ${({ isFocused }) => {
    if (isFocused) {
      return `
            position: relative;
            border-color: ${colorPrimary};
            z-index: 2;

            ${ParagraphSmall}:first-of-type {
                color: ${colorPrimary};
            }
          `;
    }

    return '';
  }}

  ${({ disabled }) => {
    if (disabled) {
      return `
        border-color: ${colorBlueGray};

        ${ParagraphSmall}:first-of-type {
          color: ${color9};
        }

        ${ParagraphSmall}:last-child {
          visibility: hidden;
        }
      `;
    }

    return '';
  }}

  ${({ isTipHidden }) => {
    if (isTipHidden) {
      return `
        ${ParagraphSmall}:last-child {
          visibility: hidden;
        }
      `;
    }

    return '';
  }}

  ${({ noData }) => {
    if (noData) {
      return `
        ${Input} {
          margin: 16px 0 auto;
        }
      `;
    }

    return '';
  }}
`;
